import script from "./B2CCheckoutTile.vue?vue&type=script&lang=ts&setup=true"
export * from "./B2CCheckoutTile.vue?vue&type=script&lang=ts&setup=true"

import "./B2CCheckoutTile.vue?vue&type=style&index=0&id=12e54aac&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12e54aac"]])

export default __exports__